import cx from 'classnames'
import { FC, useRef, useState } from 'react'
import Swiper, { default as SwiperInstance } from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'

import 'swiper/css'
import { ModalProps } from '../Modal'

import * as SC from './styled'

export type AdsMediaSliderItem = {
  title?: string
  description?: string
  media?: React.ReactNode
}

export type AdsMediaSliderModalProps = Omit<ModalProps, 'title'> & {
  className?: string
  sliderRef?: React.RefObject<Swiper>
  items: Array<AdsMediaSliderItem>
}

const AdsMediaSliderModal: FC<AdsMediaSliderModalProps> = ({
  className,
  sliderRef,
  items,
  ...modal
}) => {
  const [swiperInstance, setSwiper] = useState<SwiperInstance>()
  const paginationRef = useRef<any>(null)

  return (
    <SC.ModalStyled
      className={cx('AdsMediaSliderModal', className)}
      {...modal}
      disableDashedBorder
    >
      <SC.SwiperInstance
        modules={[Navigation, Pagination]}
        pagination={{
          clickable: true,
          el: paginationRef?.current,
        }}
        slidesPerView={1}
        autoHeight
        onInit={(swiper: any) => {
          setSwiper(swiper)

          if (sliderRef) {
            ;(sliderRef.current as any) = swiper
          }
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <SC.Item>
              {item.media && <SC.Media>{item.media}</SC.Media>}
              {(item.title || item.description) && (
                <SC.Content>
                  <SC.Title>{item.title}</SC.Title>
                  <SC.Description>{item.description}</SC.Description>
                </SC.Content>
              )}
            </SC.Item>
          </SwiperSlide>
        ))}
        <SC.Navigation
          paginationRef={paginationRef}
          onPrev={() => swiperInstance?.slidePrev()}
          onNext={() => swiperInstance?.slideNext()}
        />
      </SC.SwiperInstance>
    </SC.ModalStyled>
  )
}

export default AdsMediaSliderModal
